var _rect, _ellipse, _path, _path2, _path3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    role: "img",
    "aria-label": "SQL database logo badge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    rx: 22,
    fill: "#f7fbff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 58,
    rx: 58,
    ry: 24,
    fill: "#0071bc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 58v84c0 13 26 24 58 24s58-11 58-24V58",
    fill: "#e6f7ff",
    stroke: "#0071bc",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100c0 13 26 24 58 24s58-11 58-24",
    fill: "none",
    stroke: "#0071bc",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 136c0 13 26 24 58 24s58-11 58-24",
    fill: "none",
    stroke: "#0071bc",
    strokeWidth: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 92,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: 800,
    fill: "#0b2f55"
  }, "SQL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 126,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#52657c"
  }, "Database Exam")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.6eefb086b15b6ca5ad901c13d27c2907.svg";
export { ForwardRef as ReactComponent };